import { RealSuiteNumber } from "@ssc-booking/api-contracts/src"
import React, { useEffect, useState } from "react"
import { useQuery } from "react-query"
import { ShipDirectionIcon } from "@silversea-ssc/ui-components-react"
import PageSpinner from "../PageSpinner/PageSpinner"
import { getShipDirectionLabels } from "../LocalizedShipDeckPlansSlider/labels"
import styles from "./VerticalDeckPlan.module.scss"

type Props = {
    src: string
    deckPlanNumber: number
    availableSuiteNumbers?: readonly RealSuiteNumber[]
}
const VerticalDeckPlan: React.FC<React.PropsWithChildren<Props>> = ({ src, deckPlanNumber, availableSuiteNumbers }) => {
    const { isLoading, data } = useQuery(`svg-${src}`, () => fetch(src).then((res) => res.text()))
    const [modifiedSVG, setModifiedSVG] = useState<SVGElement>()
    const shipDirectionLabels = getShipDirectionLabels()

    useEffect(() => {
        if (data) {
            const element = document.createElement("div")
            element.innerHTML = data

            const svg = element.firstChild as SVGElement
            rotateSVG(svg)
            // NOTE: WIP code to hide unavailable suite numbers: is not working for all deck plans
            // due to the fact that some suite numbers are polygons and not text
            // if (availableSuiteNumbers && availableSuiteNumbers.length > 0)
            //     hideUnavailableSuiteNumbers(svg, deckPlanNumber, availableSuiteNumbers)

            setModifiedSVG(svg)
        }
    }, [data, deckPlanNumber, availableSuiteNumbers])

    return (
        <div className={styles.container}>
            <ShipDirectionIcon
                className={styles.shipDirectionIcon}
                variant="vertical"
                bowLabel={shipDirectionLabels.bow}
                sternLabel={shipDirectionLabels.stern}
            />
            {isLoading ? (
                <PageSpinner />
            ) : modifiedSVG ? (
                <div dangerouslySetInnerHTML={{ __html: modifiedSVG.outerHTML }} />
            ) : null}
        </div>
    )
}

export default VerticalDeckPlan

const viewBoxSize = (viewBox: string): { width: number; height: number } => {
    const [, , width, height] = viewBox.split(" ", 4)
    return { width: parseInt(width, 10), height: parseInt(height, 10) }
}

const rotateViewBox = (viewBox: string): string => {
    const { width, height } = viewBoxSize(viewBox)
    return [0, 0, height, width].join(" ")
}

const rotateSVG = (svg: SVGElement): void => {
    const viewBox = svg.getAttribute("viewBox") || "0 0 100 100"
    const { width } = viewBoxSize(viewBox)
    const rotadedViewBox = viewBox ? rotateViewBox(viewBox) : viewBox

    svg.innerHTML = `<g transform="rotate(270 ${width / 2 + 1} ${width / 2 + 1})">${svg.innerHTML}</g>`
    svg.setAttribute("viewBox", rotadedViewBox)
}
